<template>
  <v-container
    fluid
    pa-0
    :class="{ 'main-item-container-sm': $vuetify.breakpoint.xsOnly, 'main-item-container': !$vuetify.breakpoint.xsOnly , 'mt-0': forSummary && $vuetify.breakpoint.xsOnly}"
    ref="itemcontainer"
  >
    <v-layout>
      <v-flex>
        <v-card flat>
          <v-container
            fluid
            ma-0
            :class="['btn-conatiner-item elevation-2',{
              'px-3 pt-2 pb-0 mt-4': $vuetify.breakpoint.xsOnly,
              'stick-to-top': isContentTop && forSummary && $vuetify.breakpoint.xsOnly,
            }]"
            v-show="$vuetify.breakpoint.xsOnly && isContentTop && forSummary"
            ref="btnContainer"
            :box-shadow="true"
          >
            <v-layout
              row
              wrap
              :class="['btn-section',{ 'justify-start align-end': $vuetify.breakpoint.xsOnly, 'align-center': !$vuetify.breakpoint.xsOnly}]"
            >
              <v-flex xs12>
                <div v-if="$vuetify.breakpoint.xsOnly && isContentTop">
                  <v-card-title class="pt-1 pb-0 px-0" :class="cardTitleStyle">
                    <div class="headline-sm">
                      <slot name="heading" />
                    </div>
                  </v-card-title>
                  <v-card-title
                    class="pt-1 pb-0 px-0"
                    :class="cardTitleStyle"
                  >
                    <div class="sub-headline">
                      <slot name="sub-heading" />
                    </div>
                  </v-card-title>
                </div>
              </v-flex>
              <v-flex xs12 mt-2>
                <slot name="summary-options" />
              </v-flex>
            </v-layout>
          </v-container>
          <vue-perfect-scrollbar
            class="position-unset"
            :settings="{ suppressScrollY: isSuppressScrollYaxis, suppressScrollX: true }"
            :class="{
              'height-100': !isContentTop && !showScrollbar,
              'mx-h-90': !$vuetify.breakpoint.xsOnly && showScrollbar,
              'mx-h': !$vuetify.breakpoint.xsOnly && isContentTop,
              'item-container-sm px-2': $vuetify.breakpoint.xsOnly && isNextBtnEnabled && !($vuetify.breakpoint.xsOnly && forSummary),
              'item-container-sm-1 px-2': $vuetify.breakpoint.xsOnly && !isNextBtnEnabled
            }"
            ref="scroll"
            id="myscroll"
            @ps-scroll-y="scrollTo"
          >
            <v-layout
              column
            >
              <v-flex xs12>
                <v-container
                  class="pa-0 ma-0"
                  fluid
                  w-100
                >
                  <v-layout
                    align-center
                    row
                    :class="{'fill-height-sm': $vuetify.breakpoint.xsOnly }"
                  >
                    <v-flex xs12 :class="colWidth">
                      <div
                        :class="[{'helptext': !forSummary || (forSummary && ($vuetify.breakpoint.mdAndUp || isContentTop))},
                                 {'summaryPageHelpText': forSummary && ($vuetify.breakpoint.smAndDown && !isContentTop)},
                                 {'mt-4' : $vuetify.breakpoint.xsOnly}]"
                        v-if="!(isHelpTextDisabled && $vuetify.breakpoint.xsOnly)"
                      >
                        <v-card-title class="pt-1 pb-0 px-0" :class="cardTitleStyle">
                          <div class="headline-sm">
                            <slot name="heading" />
                          </div>
                        </v-card-title>
                        <v-card-title
                          class="pt-1 pb-0 px-0"
                          :class="cardTitleStyle"
                        >
                          <div class="sub-headline">
                            <slot name="sub-heading" />
                          </div>
                        </v-card-title>
                      </div>
                      <v-layout>
                        <slot name="content" />
                      </v-layout>
                      <v-layout
                        v-if="hasMessage && !$vuetify.breakpoint.xsOnly"
                        class="mt-1"
                      >
                        <v-flex xs12 sm8>
                          <bizgain-message-component type="error" :value="true" :message="bizgainMessage[0].message" />
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="!$vuetify.breakpoint.xsOnly && !isContentTop && isNextBtnEnabled">
                        <slot name="btn-content" />
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </vue-perfect-scrollbar>
          <v-container
            v-if="hasMessage && $vuetify.breakpoint.xsOnly"
            fluid
            :class="{
              'mx-5': !$vuetify.breakpoint.xsOnly,
              'px-2 mx-0': $vuetify.breakpoint.xsOnly}"
          >
            <v-layout>
              <v-flex xs12 sm8>
                <bizgain-message-component type="error" :value="true" :message="bizgainMessage[0].message" />
              </v-flex>
            </v-layout>
          </v-container>
          <v-container
            fluid
            ma-0
            :class="{
              'pa-0 pt-2': !$vuetify.breakpoint.xsOnly,
              'next-btn-overflow-btn-margin': !$vuetify.breakpoint.xsOnly && isScrollReachedBottom,
              'px-3 pt-2 pb-0 mt-2': $vuetify.breakpoint.xsOnly,
              'summary-options': isContentTop && forSummary && !$vuetify.breakpoint.xsOnly,
            }"
            v-show="($vuetify.breakpoint.xsOnly || isContentTop) && isNextBtnEnabled && !($vuetify.breakpoint.xsOnly && isContentTop && forSummary)"
            class="btn-conatiner-item"
            ref="btnContainer"
            :box-shadow="(!$vuetify.breakpoint.xsOnly && isScrollReachedBottom) || ($vuetify.breakpoint.xsOnly) && hasBtnContent"
          >
            <v-layout
              class="btn-section"
              :class="{ 'justify-start align-end': $vuetify.breakpoint.xsOnly, 'align-center': !$vuetify.breakpoint.xsOnly}"
            >
              <slot name="btn-content" />
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {
  VCard,
  VCardTitle,
  VLayout,
  VFlex,
  VContainer
} from 'vuetify/lib';
import BizgainMessageComponent from 'Components/BizgainMessageComponent/BizgainMessageComponent.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    VCard,
    VCardTitle,
    VLayout,
    VFlex,
    VContainer,
    BizgainMessageComponent
  },
  data() {
    return {
      isScrollReachedBottom: false,
      setDynamicHeightResizeObserver: null,
      scrollResizeObserver: null,
      hasBtnContent: true
    }
  },
  computed: {
    ...mapGetters(['bizgainMessage']),
    hasMessage(){
      return this.bizgainMessage.length > 0;
    }
  },
  props: {
    isNextBtnEnabled: {
      type: Boolean,
      default: false
    },
    isHelpTextDisabled: {
      type: Boolean,
      default: false
    },
    colWidth: {
      type: Object,
      default: null
    },
    cardTitleStyle: {
      type: String,
      default: 'px-0'
    },
    isContentTop: {
      type: Boolean,
      default: false
    },
    isContentScrollable: {
      type: Boolean,
      default: false
    },
    showScrollbar: {
      type: Boolean,
      default: false
    },
    viewPortHeight: {
      type: String,
      default: '206px'
    },
    isSuppressScrollYaxis: {
      type: Boolean,
      default: false
    },
    forSummary: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    scrollTo() {
      this.$nextTick(() => {
        const element = this.$refs.scroll && this.$refs.scroll.$el;
        if (element) {
          this.isScrollReachedBottom = !(Math.floor(element.scrollHeight - element.scrollTop) === element.clientHeight);
        }
      });
    },
    setDynamicHeight() {
      let vh = (window.innerHeight) * 0.01;
      this.$nextTick(() => {
        const scrollElement = this.$refs.scroll && this.$refs.scroll.$el;
        if (scrollElement) {
          if(this.isContentScrollable) {
            vh += 1;
          }
          scrollElement.style.setProperty('--vh', `${vh}px`);
          scrollElement.style.setProperty('--viewPortHeight', this.viewPortHeight);
        }
      })
    },
    setNextBtnVisibility(value) {
      this.hasBtnContent = value;
    },
    setViewPortHeight(height){
      var scrollElement = this.$refs.scroll && this.$refs.scroll.$el;
      scrollElement.style.setProperty('--viewPortHeight', height);
    }
  },
  created() {
    this.setDynamicHeight();
    if (!this.$vuetify.breakpoint.smAndDown) {
      this.scrollResizeObserver = new ResizeObserver(() => this.scrollTo());
      this.$nextTick(() => {
        const element = this.$refs.scroll && this.$refs.scroll.$el;
        if (element && this.isContentTop) {
          this.scrollResizeObserver.observe(element);
        }
      });
    }
    window.addEventListener('resize', this.setDynamicHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setDynamicHeight);
    if (this.scrollResizeObserver) {
      this.scrollResizeObserver.disconnect();
    }
  }
}
</script>
<style lang="scss" scoped>
.main-item-container {
  max-height: calc(100vh - 60px);
  min-height: calc(100vh - 60px);
  display: flex;
}

  .summary-options{
    position: absolute !important;
    bottom: 0 !important;
  }

  .stick-to-top{
    z-index: 1;
    position: sticky !important;
    top: 0 !important;
    margin-top: 0px !important;
  }
.main-item-container-sm {
  padding-top: 7px !important;
  display: flex;
  height: calc(var(--vh, 1vh) * 100 - 100px) !important;
}

.height-100 {
  height: calc(100% - 33px) !important;
}

.mx-h {
  max-height: 81vh;
}

@media screen and (max-height: 640px) and (min-height: 600px){
  .mx-h{
    max-height: 78vh;
  }
}

@media screen and (max-height: 680px) and (min-height: 641px){
  .mx-h{
    max-height: 79.5vh;
  }
}

@media screen and (max-height: 740px) and (min-height: 681px){
  .mx-h{
    max-height: 80.5vh;
  }
}

@media screen and (max-height: 780px) and (min-height: 741px){
  .mx-h{
    max-height: 81.5vh;
  }
}

@media screen and (max-height: 840px) and (min-height: 781px){
  .mx-h{
    max-height: 82.5vh;
  }
}

.mx-h-90{
  max-height: 91vh;
}

.item-container-sm {
  display: flex;
  height: calc(var(--vh, 1vh) * 100 - var(--viewPortHeight) + 45px) !important;
}

.item-container-sm-1 {
  display: flex;
  height: calc(var(--vh, 1vh) * 100 - 154px ) !important;
}

.box-shadow {
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: var(--v-white-base);
}

.headline{
  color: var(--v-black-base) !important;
}

.headline-sm {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: var(--v-black-base) !important;
}

.sub-headline{
  font-size: 16px !important;
  color: var(--v-base-light-darken4) !important;
}

.helptext {
  padding-bottom: 32px !important;
}
.summaryPageHelpText {
  padding-bottom: 0px !important;
}
@media (min-width: 600px) {
  .helptext {
    line-height: 33px !important;
  }
  .summaryPageHelpText{
    line-height: 33px !important;
  }
}

@media (min-width: 600px) {
  .headline-sm {
    font-size: 26px !important;
    font-weight: 400 !important;
    color: var(--v-black-base) !important;
  }
}

 .position-unset {
  position: unset;
 }

.fill-height-sm {
  margin-top: -8px !important;
}

.btn-section{
  z-index: 1000 !important
}

.next-btn-overflow-btn-margin {
  padding-top: 6px !important;
}
</style>